import { HTTPError } from '../http/error';

const marker = '\x1eCLOVYR_EXEC_RESULT:';

// Headers arrive before the command finishes. Consume the completion record
// before resolving exec(), so even callers that ignore stdout await completion.
export async function completeExecResponse(response: Response): Promise<Response> {
  let text: string;
  try {
    text = await response.text();
  } catch {
    throw new HTTPError('Command stream interrupted; outcome unknown', 602, '');
  }
  if (response.headers.get('X-Exec-Protocol') === '1') {
    const index = text.lastIndexOf(marker);
    if (index < 0)
      throw new HTTPError('Missing command completion record; outcome unknown', 602, text);
    let result: { exitCode: number; error?: string };
    try {
      result = JSON.parse(text.slice(index + marker.length));
      if (!Number.isInteger(result?.exitCode)) throw new Error('invalid exit code');
      if (result.error !== undefined && typeof result.error !== 'string')
        throw new Error('invalid error');
    } catch {
      throw new HTTPError('Invalid command completion record', 602, text);
    }
    text = text.slice(0, index);
    if (result.exitCode !== 0 || result.error) {
      throw new HTTPError(
        result.error || `Command exited with status ${result.exitCode}`,
        602,
        text
      );
    }
  }
  const headers = new Headers(response.headers);
  headers.delete('Content-Length');
  headers.delete('Content-Encoding');
  headers.delete('Transfer-Encoding');
  return new Response(text, { status: response.status, statusText: response.statusText, headers });
}
